import { pipe } from '@fedsim/helpers'
import weighted from 'weighted'

// functions
export function getPercentageOf (total, amount) {
  const result = (amount / total) * 100

  return result
}

// item function
export function getPoints (item) {
  const result = item?.manager ? 0 : item?.wrestler?.points || 0

  return result
}

export function mapWeight (item, totalPoints) {
  const points = getPoints(item)
  const weight = getPercentageOf(totalPoints, points)
  const result = Object.assign({}, item, { weight })

  return result
}

// collection functions
export function getgroupIds (collection) {
  const rawgroupIds = collection.map(e => e.groupId)
  const result = Array.from(new Set(rawgroupIds))

  return result
}

function getTotalPoints (collection) {
  const result = collection.reduce((prev, curr) => {
    return prev + curr.wrestler.points
  }, 0)

  return result
}

function getWeights (collection) {
  const result = collection.map(item => item.weight)

  return result
}

// filter
function filterNoManagers (collection) {
  const result = collection.filter(item => !item.manager)

  return result
}

function removeExcess (collection) {
  const result = collection.map(item => {
    delete item.wrestler
    delete item.weight

    return item
  })

  return result
}

// collection functions
function mapWeights(collection) {
  if(collection.length === 0) {
    return []
  }
  const totalPoints = getTotalPoints(collection)
  const groupIds = getgroupIds(collection)
  const hasEnoughTeams = groupIds && groupIds.length > 1
  const mapper = item => mapWeight(item, totalPoints)
  const result = hasEnoughTeams ? collection.map(mapper) : collection

  return result
}

function selectWeight(collection) {
  if(collection.length === 0) {
    return []
  }
  const weights = getWeights(collection)
  const result = weighted.select(weights)

  return result
}

function selectWinnerIndex(collection) {
  if(collection.length === 0) {
    return -1
  }
  const selectedWeight = selectWeight(collection)
  const findIndex = item => item.weight === selectedWeight
  const result = collection.findIndex(findIndex)

  return result
}

function mapWinners(collection) {
  if(collection.length === 0) {
    return []
  }
  let result = collection
  const winnerIndex = selectWinnerIndex(collection)
  const winninggroupId = collection?.[winnerIndex]?.groupId

  if (winnerIndex > -1) {
    result = result.map(item => {
      const winner = item.groupId === winninggroupId

      item.loser = !winner
      item.winner = winner

      return item
    })
  }

  return result
}

export const simulate = collection =>
  pipe(
    filterNoManagers, //
    mapWeights, //
    mapWinners, //
    removeExcess
  )(collection)
